export default <T extends object, U extends keyof T>(
  object: T,
  props: U[],
): Pick<T, U> => {
  const picked: any = {}

  props.forEach(prop => {
    if (object[ prop ] !== undefined) {
      picked[ prop ] = (object as any)[ prop ]
    }
  })

  return picked
}



// WEBPACK FOOTER //
// ./src/utils/pick/pick.ts